import { Button } from "@flat-ui";
import { Link, Stack, StackProps } from "@mui/material";
import { EXPORTER_APP_OS_DATA, OperatingSystem } from "@pages/settings/export-workspace/exporter-app-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

interface Props {
  /** The direction of the stack */
  direction: StackProps["direction"];
}

/** Renders the buttons to download the Export app */
export function ExporterApp({
  direction,
}: Props): JSX.Element {
  const { trackEvent } = useTrackEvent();

  function trackDownloadEvent(system: OperatingSystem): void {
    trackEvent({
      name: WorkspaceEvents.downloadExporterApp,
      props: {
        system,
      },
    });
  }

  return (
    <Stack
      direction={direction}
      spacing={2}
      sx={{
        justifyContent: "flex-end",
      }}
    >
      {Object.values(EXPORTER_APP_OS_DATA).map((osData) => (
        <Link
          key={osData.system}
          href={osData.downloadUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            variant="secondary"
            icon={osData.icon}
            onClick={() => trackDownloadEvent(osData.system)}
          >
            {osData.name}
          </Button>
        </Link>
      ))}
    </Stack>
  );
}
